import { Box, Container } from '@mui/material';
import { DELETE_PLACE, LIST_PLACES } from "../../../graphql/admin-requests";
import React from 'react';
import PlaceListResults from './PlaceListResults';
import EntityListToolbar from '../subcomponents/EntityListToolbar';
import { useEntityList } from '../../../hooks/useEntityList';
import CUPlace from "../CreateUpdateComponents/Place";


function PlaceList() {

    const {
        items: places,
        totalCount,
        limit,
        setLimit,
        offset,
        setOffset,
        updateSearch,
        loadData,
        handleDelete: handleDeletePlace,
    } = useEntityList({
        listQuery: LIST_PLACES,
        listDataKey: "allPlaces",
        deleteMutation: DELETE_PLACE,
        deleteVariableName: "placeUid",
        deleteErrorMessage: "Impossible de supprimer la salle",
        deleteSuccessMessage: "Salle supprimée",
        initialLimit: 5,
    });

    return (
        <Container component="main" maxWidth={false}>
            <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}>
                <Container maxWidth={false}>
                    <EntityListToolbar
                        loadData={loadData}
                        updateSearch={updateSearch}
                        searchPlaceholder="Rechercher une salle"
                        CreateComponent={CUPlace}
                    />
                    <Box sx={{ pt: 3 }}>
                        <PlaceListResults
                            places={places}
                            limit={limit}
                            offset={offset}
                            totalCount={totalCount}
                            setLimit={setLimit}
                            setOffset={setOffset}
                            handleDeletePlace={handleDeletePlace} />
                    </Box>
                </Container>
            </Box>
        </Container >
    )
};

export default PlaceList;
